import { Wrapper } from "./footer.styles";
import { Container } from "reactstrap";
import { memo, useState } from "react";
import { activateNotification } from "../../utils/notifications-utils";
import { validateEmail } from "../../utils/email-utils";
import { joinWaitlist } from "../../api/firebase.requests";
import { useLocation } from "react-router";
import { useMediaQuery } from "../../hooks/media-query.hook";
import { theme } from "../../theme";

export const FooterComponent = memo(() => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [email, setEmail] = useState("");
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const hideNavAndFooter =
    location.pathname.startsWith("/cart") ||
    location.pathname.startsWith("/guest-sign-in");

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (validateEmail(email) === true) {
      setLoading(true);
      await joinWaitlist(email)
        .then((data) => {
          activateNotification({
            title: "Success",
            body: "You have successfully joined our newsletter.",
          });
          // console.log(data);
        })
        .catch((err) => {
          activateNotification({
            title: "Error",
            body: JSON.stringify(err),
          });
        })
        .finally(() => {
          setEmail("");
          setLoading(false);
        });
    } else {
      activateNotification({
        title: "Error",
        body: "This email address is not valid",
      });
      setEmail("");
    }
  };

  if (isMobile && hideNavAndFooter) return null;
  return (
    <Wrapper>
      <div className="privacy_and_conditions">
        <Container className="d-flex">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-and-conditions">Terms of Service</a>
          <a href="/refund-policy">Refund Policy</a>
          <p className="copyright-text">
            © {new Date().getFullYear()} AgroGrid. All rights reserved.
          </p>
        </Container>
      </div>
    </Wrapper>
  );
});
